import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function Journal() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [article, setArticle] = useState(null);

  useEffect(() => {
    if (slug) {
      api.get(`/journal/${slug}`).then(({ data }) => setArticle(data)).catch(() => setArticle(null));
    } else {
      api.get("/journal").then(({ data }) => setArticles(data)).catch(() => {});
    }
  }, [slug]);

  if (slug) {
    if (!article) return <div className="pt-40 text-center text-slate-500 font-mono text-sm">Loading…</div>;
    return (
      <div className="px-4 sm:px-8 lg:px-12 pt-28 pb-20 max-w-3xl mx-auto">
        <Link to="/journal" className="text-xs font-mono text-slate-500 flex items-center gap-1 mb-8"><ArrowLeft size={12} /> Journal</Link>
        {article.cover && <img src={article.cover} alt={article.title} className="w-full h-64 object-cover rounded-3xl mb-8 border border-white/10" />}
        <div className="mono-label mb-3">{article.author} · {article.created_at?.slice(0, 10)}</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight">{article.title}</h1>
        <div className="laser-line my-8" />
        <p className="text-slate-300 leading-relaxed text-base">{article.body}</p>
      </div>
    );
  }

  return (
    <div className="px-4 sm:px-8 lg:px-12 pt-28 pb-20 max-w-7xl mx-auto">
      <div className="mono-label mb-3">CMS / Journal</div>
      <h1 className="font-serif text-5xl sm:text-6xl text-white mb-12">The CG Labz Journal</h1>
      <div className="grid md:grid-cols-3 gap-6">
        {articles.map((a) => (
          <Link key={a.id} to={`/journal/${a.slug}`} data-testid={`journal-card-${a.slug}`}
            className="glass rounded-3xl overflow-hidden group hover:border-cyan-400/40 transition-colors">
            {a.cover && <img src={a.cover} alt={a.title} className="w-full h-48 object-cover group-hover:scale-[1.02] transition-transform duration-500" />}
            <div className="p-6">
              <div className="text-[10px] font-mono uppercase tracking-widest text-cyan-400/70 mb-2">{a.created_at?.slice(0, 10)}</div>
              <div className="font-serif text-2xl text-white leading-snug">{a.title}</div>
              <p className="text-sm text-slate-400 mt-2">{a.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
